import { string } from 'yup';

export const descriptionSchema = string()
  .when('description', {
    is: (value: string) => !!value,
    then: string().max(1000, 'No more than 1000 characters'),
  });
